import * as React from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'


interface OnChangeFunc {
    (value: Airline[]): void
}


export interface Airline {
    id: number
    iata_code: string
    name: string
}


interface AirlineAutocompleteProps {
    id?: string
    name: string
    onChange: OnChangeFunc
    onBlur?: Function
    selected?: Airline
}


export default
class AirlineAutocomplete extends React.Component<AirlineAutocompleteProps> {
    state = {
        requestCount: 0,
        airlines: [] as Airline[],
        defaultValue: null,
    }

    onSearch = async (query) => {
        this.setState({
            requestCount: this.state.requestCount + 1
        })

        let data = await (
            await fetch(`/api/airlines?search=${query}&random=${Math.random()}`)
        ).json()

        this.setState({
            requestCount: this.state.requestCount - 1,
            airlines: data,
        })
    }

    render () {
        return <AsyncTypeahead
            id={this.props.id}
            name={this.props.name}
            options={this.state.airlines}
            labelKey="name"
            onSearch={this.onSearch}
            isLoading={this.state.requestCount > 0}
            minLength={2}
            onChange={this.props.onChange}
            onBlur={this.props.onBlur}
            selected={this.props.selected ? [this.props.selected] : null}
        />
    }
}


